export default __webpack_public_path__ + "static/november-pro-medium-2550c811f51243d3f94ba3a57daad426.woff2";